import { capitalize, Spacer } from "@qivia/ui";
import { colors } from "@qivia/ui/src/styles/figmaColors";
import styled from "styled-components";
import {
  ArrowDownwardOutlined,
  ArrowUpwardOutlined,
} from "@qivia/ui/src/designSystem/materialUi/materialUi";

export const DeviationCell = ({
  statusSeverity,
  value,
}: {
  statusSeverity: string | undefined;
  value: string;
}) => (
  <StyledDeviationCell>
    {statusSeverity === "warning" && (
      <StyledDeviationIcon
        $color={colors["colors/system/warning/warning_dark"]}
      >
        <ArrowDownwardOutlined />
      </StyledDeviationIcon>
    )}
    {statusSeverity === "error" && (
      <StyledDeviationIcon $color={colors["colors/system/error/error_dark"]}>
        <ArrowUpwardOutlined />
      </StyledDeviationIcon>
    )}
    {statusSeverity && statusSeverity !== "success" && <Spacer x={0.25} />}
    {capitalize(value)}
  </StyledDeviationCell>
);

const StyledDeviationCell = styled.div`
  display: flex;
  align-items: center;
`;

const StyledDeviationIcon = styled.div<{ $color: string }>`
  display: flex;
  align-items: center;
  & svg {
    width: 1rem;
    height: 1rem;
    fill: ${({ $color }) => $color};
  }
`;
